import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import rentImage from 'src/images/tours/timetable/rent.png';
import capacityImage from 'src/images/tours/timetable/capacity.png';

/**
 * Hook to create a guided tour for the timetable component
 * Uses Driver.js to highlight elements and show explanations
 */
export function useTimetableTour() {
    const { t } = useTranslation();

    const startTour = useCallback(() => {
        const hasRent = document.querySelector(
            '#timetable-piece.RENT, #timetable-piece.GAME, #timetable-piece.CLASS, #timetable-piece.EVENT, #timetable-piece.BUSY',
        );
        const hasCapacity = document.querySelector(
            '#timetable-piece .capacity',
        );

        const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            stagePadding: 4,
            nextBtnText: t('tour.next'),
            prevBtnText: t('tour.back'),
            doneBtnText: t('tour.last'),
            progressText: '{{current}} / {{total}}',
            steps: [
                {
                    popover: {
                        title: t('tour.timetable.title'),
                        description: t('tour.timetable.description'),
                        side: 'bottom',
                        align: 'center',
                    },
                },
                {
                    element: '#timetable-column',
                    popover: {
                        title: t('tour.timetable.facility.title'),
                        description: t('tour.timetable.facility.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: '#timetable-piece.FREE',
                    popover: {
                        title: t('tour.timetable.free.title'),
                        description: t('tour.timetable.free.description'),
                        side: 'right',
                        align: 'start',
                    },
                },
                hasRent
                    ? {
                          element:
                              '#timetable-piece.RENT, #timetable-piece.GAME, #timetable-piece.CLASS, #timetable-piece.EVENT, #timetable-piece.BUSY',
                          popover: {
                              title: t('tour.timetable.rent.title'),
                              description: t('tour.timetable.rent.description'),
                              side: 'right',
                              align: 'start',
                          },
                      }
                    : {
                          element: '#timetable-piece.FREE',
                          popover: {
                              title: t('tour.timetable.rent.title'),
                              description: `${t('tour.timetable.rent.description')}<img style='padding-top:10px; max-width: 100%' src='${rentImage}'/>`,
                              side: 'right',
                              align: 'start',
                          },
                      },
                {
                    element: '#timetable-piece .price',
                    popover: {
                        title: t('tour.timetable.price.title'),
                        description: t('tour.timetable.price.description'),
                        side: 'top',
                        align: 'end',
                    },
                },
                hasCapacity
                    ? {
                          element: '#timetable-piece .capacity',
                          popover: {
                              title: t('tour.timetable.capacity.title'),
                              description: t(
                                  'tour.timetable.capacity.description',
                              ),
                              side: 'top',
                              align: 'start',
                          },
                      }
                    : {
                          element: '#timetable-piece.FREE',
                          popover: {
                              title: t('tour.timetable.capacity.title'),
                              description: `${t(
                                  'tour.timetable.capacity.description',
                              )}<img style='padding-top:10px; max-width: 100%' src='${capacityImage}'/>`,
                              side: 'right',
                              align: 'start',
                          },
                      },
            ],
        });

        driverObj.drive();
    }, [t]);

    return { startTour };
}
